<template>
  <div
    class="toggle-card-box card no-padding"
    :class="{ disabled: isDisabled }">
    <div
      class="toggle-card-header"
      @click="selected"
      :class="{ opened: isOpened }">
      <div class="info-box">
        <div class="title-holder">
          <LogosSVG :name="product.shipping_agent_name" size="62" class="m-r-20" />
          <div>
            <span class="sub-title m-b-5">{{ product.shipping_product_name}}</span>
            <span class="title b-block m-b-5">{{ `${ getPickupFromString }` }}</span>
            <span v-if="product.note" style="padding: 4px; margin-bottom: 4px; font-size: 13px; border-radius: 4px; background: #000; color: #fff">
            <Icon class="icon" fill-color="#fff" style="color: #fff; position:relative; top: 1px; display: inline-block" name="info" size="12"/>
            {{ product.note.trim() }}
          </span>
            <span class="sub-title">{{ getShipmentMustBeReadyString }}</span>
          </div>
        </div>
        <div>
        <span class="price-title">
          <span v-if="product.prices && product.total_price">{{ product.total_price | currency }}</span>
          <span v-else >-</span>
        </span>
        </div>
      </div>
      <div class="icon-holder">
        <Icon class="icon" v-show="!isOpened && !isDisabled"
              name="arrowRight"
              size="30" />
        <Icon class="icon" v-show="isOpened && !isDisabled"
              name="arrowDown"
              size="30" />
        <Icon class="icon color-warning" v-if="isDisabled"
              name="info"
              v-tooltip="{content: getErrorMsgTxt, class: 'pickup-popup-tooltip'}"
              size="26" />
      </div>
    </div>
    <div class="toggle-card-body" v-show="isOpened">
      <!-- ERROR -->
<!--      <div v-if="product.prices_error">-->
<!--        {{ product.prices_error.message }}-->
<!--      </div>-->
      <!-- PARCEL -->
      <div v-if="visibleBookingButton">
        <div>
          <div class="row m-b-20">
            <div :class="{'col-xs-6': pickupTimeFrom, 'col-xs-12': !pickupTimeFrom}">
              <InputSelect
                :label="$t('ready_pickup_time')"
                v-model="pickupTimeFrom"
                :options="getPickupTimeFromRangeArray" />
            </div>
            <div class="col-xs-6">
              <InputSelect
                v-if="pickupTimeFrom"
                :label="$t('latest_pickup_time')"
                v-model="pickupTimeUntil"
                :options="getPickupTimeUntilRangeArray" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 m-b-20">
              <InputText
                :label="$t('Note to the driver')"
                v-model="pickupDriverNote" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12" v-if="product.booked_pickup_id && pageType === 'view'"  style="margin-bottom: 25px">
              <InputSelect
                :label="$t('do_you_want_to_use_existing_booked_pickup')"
                v-model="shouldMoveShipmentsToExistingPickup"
                :options="[{text: 'yes', value: 1}, {'text': 'no', value: 0}]"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- SHIPMENT -->
      <h2 class="details-title">{{ $t('Price details') }}</h2>
      <div class="toogle-price-list opened">
        <!-- Title -->
        <div class="price-list">
          <div v-for="(priceItem, index) in product.prices" :key="`pricePDDt-${index}`">
            <span v-if="priceItem.type === 'vat'">{{ `${$t(priceItem.name)} (${user_vat_percent ? user_vat_percent : product.prices_data.vat_percent}%)`}}</span>
            <span v-else >{{ priceItem.name }}</span>
            <span v-if="priceItem.sales_price != null">{{ priceItem.sales_price | currency }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="total-price" v-if="product.prices && product.total_price">
          <span class="total-price-title">{{ getTotalPriceText(product) }}</span>
          <span class="total-price-price">{{ product.total_price | currency }}</span>
        </div>
      </div>
      <message
        v-if="product.booked_pickup_id && pageType === 'index'"
        style="margin-bottom: 25px" name="warning"
        :customIcon="'truck'"
        :data="data={data: getPickupNotificationTxt, type: 'custom-message'}">
      </message>
      <!-- BOOKING -->
      <Btn
        v-if="visibleBookingButton"
        @btnClick="bookPickup"
        :loading="loadingButton"
        :disabled="disableButton"
        class="brand text-center m-b-20"
        :btnText="$t('book_pickup')"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

import Btn from "@/components/elements/buttons";
import LogosSVG from "@/assets/images/logosSVG";
import PriceCard from "@/components/global/toggleCard/priceCard.vue";
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";
import i18n from "@/i18n";

export default {
  name: 'ProductCard',
  components: {
    Btn,
    LogosSVG,
    PriceCard,
    Popup,
    Checkbox,
    InputSelect,
    InputText,
    Calendar,
    Toggle,
  },
  props: {
    pageType: {
      type: [String],
      default: '',
    },
    pickupDate: {
      type: [String, Date],
      default: '',
    },
    showPrices: {
      type: [Boolean],
      default: false,
    },
    product: {
      type: Object,
      default: {},
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
    loadingButton: {
      type: Boolean,
      default: false,
    },
    enabledProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return{
      shouldMoveShipmentsToExistingPickup: 0,
      isOpenedPopup: false,
      pickupDriverNote: '',
      pickupTimeUntil: '',
      pickupTimeFrom: '',
      // Other
      APIerror: '',
      scheduleHours: [
        '06:00', '06:30',
        '07:00', '07:30',
        '08:00', '08:30',
        '09:00', '09:30',
        '10:00', '10:30',
        '11:00', '11:30',
        '12:00', '12:30',
        '13:00', '13:30',
        '14:00', '14:30',
        '15:00', '15:30',
        '16:00', '16:30',
        '17:00', '17:30',
        '18:00', '18:30',
        '19:00', '19:30',
        '20:00',
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_booking_systems',
      'get_user',
      'get_active_subaccount',
      'get_currency',
    ]),
    getPickupNotificationTxt() {
      return `${this.$t('pickup_has_been_booked_on_this_address')} </br> ${this.$t('between')} ${this.product.ready_time} ${this.$t('and')} ${this.product.close_time}`;
    },
    getErrorMsgTxt() {
      let msg = '';

      if (this.product.goods_type_error) {
        msg = 'Unallowed goods type on shipment(s) with awb ' + this.product.goods_type_error.awbs.toString();
      }

      if (this.product.pickup_in_past_error) {
        msg = 'Pickup cannot be in past';
      }

      if (this.product.pickup_today_time_error) {
        msg = 'Current pickup time is not allowed. Book pickup for tomorrow';
      }

      if (this.product.product_error) {
        msg = 'Unallowed product on shipment(s) with awb ' + this.product.product_error.awbs.toString();
      }

      return msg;
    },
    visibleBookingButton() {
      return true;
    },
    getPickupFromString() {
      return i18n.t('book_pickup_at_latest_for_same_day', {call_time: this.product.call_time});
      //return `${this.$t('pickup_from')} ${this.product.ready_time} ${this.$t('to')} ${this.product.close_time}`;
    },
    getShipmentMustBeReadyString() {
      return ''; //`${this.$t('shipment_must_be_ready_latest_at')} ${this.product.ready_time}`;
    },
    isDisabled() {
      if(this.product.product_error
        || this.product.goods_type_error
        || this.product.pickup_in_past_error
        || this.product.pickup_today_time_error) {
        //Prices error should not disable product, only price will not be shown
        return true;
      } else {
        return false;
      }
    },
    getPickupTimeUntilRangeArray() {
      if (!this.pickupTimeFrom) {
        return [];
      }
      let currentDate = this.getFormatedDate(new Date());
      let pickupDate = this.getFormatedDate(this.pickupDate);

      const currentTime = this.roundToNearest30MinAfterGiven(currentDate.time);
      let startTime = this.addTime(this.pickupTimeFrom, '01:30');
      let startUntilHour, endUntilHour;
      //If current time is after start time use current time for range
      if (currentDate.date == pickupDate.date && currentTime > startTime) {
        startUntilHour = currentTime;
      } else {
        startUntilHour = startTime;
      }

      if (startUntilHour < '12:00') {
        startUntilHour = '12:00';
      }

      endUntilHour = '18:00';

      if (currentDate.date === pickupDate.date && currentTime > endUntilHour) {
        return [];
      }

      return this.findArrayRangeHours(startUntilHour, endUntilHour);
    },
    getPickupTimeFromRangeArray() {
      let currentDate = this.getFormatedDate(new Date());
      let pickupDate = this.getFormatedDate(this.pickupDate);

      const currentTime = this.roundToNearest30MinAfterGiven(currentDate.time);
      let startTime = '09:00';
      let startFromHour, endFromHour;
      //If current time is after start time use current time for range
      if (currentDate.date == pickupDate.date && currentTime > startTime) {
        startFromHour = currentTime;
      } else {
        startFromHour = startTime;
      }
      //Close time - 1:30 hour
      endFromHour = this.substractTime(this.product.close_time, '01:30');

      //If agent is gls express or ups
      if ([10, 6].includes(parseInt(this.product.shipping_agent_id)) && this.product.ready_time) {
        endFromHour = this.product.ready_time;
      }

      if (currentDate.date === pickupDate.date && currentTime > endFromHour) {
        return [];
      }

      return this.findArrayRangeHours(startFromHour, endFromHour);
    },
  },
  created() {
    console.log('product component created')
    if (this.get_booking_systems) {
      const systemSettings = this.get_booking_systems.items[0];
    }
  },
  methods: {
    addTime(vreme, vremeZaDodavanje) {
      // Razdvajanje sati i minuta
      const [ulazniSati, ulazneMinute] = vreme.split(":").map(Number);
      const [dodajSati, dodajMinute] = vremeZaDodavanje.split(":").map(Number);

      // Dodavanje vremenaZaDodavanje vremenu
      let rezultatSati = ulazniSati + dodajSati;
      let rezultatMinute = ulazneMinute + dodajMinute;

      // Ako su minute veće od 60, dodaj sate i smanji minute
      if (rezultatMinute >= 60) {
        rezultatSati += Math.floor(rezultatMinute / 60);
        rezultatMinute %= 60;
      }

      // Formatiranje rezultata
      return `${rezultatSati.toString().padStart(2, '0')}:${rezultatMinute.toString().padStart(2, '0')}`;
    },
    substractTime(vreme, vremeZaOduzimanje) {
      // Razdvajanje sati i minuta
      const [ulazniSati, ulazneMinute] = vreme.split(":").map(Number);
      const [oduzmiSati, oduzmiMinute] = vremeZaOduzimanje.split(":").map(Number);

      // Oduzimanje vremenaZaOduzimanje od vremena
      let rezultatSati = ulazniSati - oduzmiSati;
      let rezultatMinute = ulazneMinute - oduzmiMinute;

      // Ako su minute negativne, smanji sate i dodaj 60 minuta
      if (rezultatMinute < 0) {
        rezultatSati -= 1;
        rezultatMinute += 60;
      }

      // Formatiranje rezultata
      return`${rezultatSati.toString().padStart(2, '0')}:${rezultatMinute.toString().padStart(2, '0')}`;
    },
    findEndHour(hour) {
      let hours = Number(hour.slice(0, 2)) - 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      let minutes = hour.slice(3);
      return hours + ':' + minutes;
    },
    findArrayRangeHours(from, to) {
      let arr = [...this.scheduleHours];
      return arr.slice(arr.indexOf(from), arr.indexOf(to) + 1).map((time) => {
        return {text: time, value: time};
      });
    },
    getFormatedDate(dateTime) {
      let d = new Date(dateTime);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let hours = String(d.getHours());
      let minutes = String(d.getMinutes());

      if (day < 10) day = `0${day}`
      if (month < 10) month = `0${month}`
      if (hours.length == 1) hours = `0${hours}`
      if (minutes.length == 1) minutes = `0${minutes}`

      return {
        date: `${d.getFullYear()}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    },
    addHour(hour){
      let hours = Number(hour.slice(0, 2)) + 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      let minutes = hour.slice(3);
      return hours + ':' + minutes;
    },
    findRoundHour(hour){
      let hours = Number(hour.slice(0, 2)) + 1;
      if(hours.toString().length == 1) hours = '0' + hours;
      return hours + ':' + '00';
    },
    roundToNearest30MinAfterGiven(time) {
      let timeParts = time.split(":");
      let hours = parseInt(timeParts[0], 10);
      let minutes = parseInt(timeParts[1], 10);

      if (minutes <= 30) {
        minutes = 30;
      } else {
        minutes = 0;
        if (hours < 23) {
          hours++; // Ako nije trenutno 23:30, povećavamo sat za jedan
        } else {
          hours = 0; // Ako je trenutno 23:xx, postavljamo na 00:00
        }
      }

      // Konstruisanje rezultujućeg vremena u formatu "HH:MM"
      return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    },
    getTotalPriceText(product) {
      return Number(product.prices?.vat_percent) ?  this.$t('total_incl_vat') : this.$t('total');
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selected() {
      if(this.isDisabled) return;
      this.$emit('selected', {
        product: this.product,
      });
    },
    bookPickup() {
      this.$emit('bookPickup', {
        should_move_shipments_to_existing_pickup: this.shouldMoveShipmentsToExistingPickup,
        pickup_driver_note: this.pickupDriverNote,
        pickup_time_from: this.pickupTimeFrom,
        pickup_time_until: this.pickupTimeUntil,
        product: this.product
      });
    },
    openPopup() {
      this.isOpenedPopup = true;
    },
    closePopup() {
      this.isOpenedPopup = false;
    },
  },
}
</script>
